<template>
	<popup class="new-asset-group-popup" title="Create new saved asset group" @close="close" >
		<template v-slot:content>
			<div class="layout-column flex __content">
				<div>
					<input-field small label="Asset group name" v-model="group.name" />
				</div>
			</div>
		</template>
		<template v-slot:actions>
			<v-button label="Create asset group" slim :loading="loading" @click="add" />
			<v-button label="Cancel" slim border @click="close" />
		</template>
	</popup>
</template>

<script>
import Popup from '@/components/base/popup';
import VButton from '@/components/base/v-button';
import InputField from '@/components/base/input-field';
import {mapGetters} from "vuex";
import API from '@/api';
import SelectField from "@/components/base/select-field";

export default {
	name: "new-asset-group-popup",
	components: {SelectField, InputField, Popup, VButton},
	// props:['groups'],
	mixins:[API],
	data() {
		return {
			loading: false,
			group:{
				name:'',
			}
		}
	},
	computed:{
		...mapGetters(['page_findAll', 'current_popup','savedAssetGroups']),
		stepId(){
			return this.$store.state.page.initial ? this.$store.state.page.initial.step : '';
		},
		funnelId(){
			return this.$store.state.page.initial ? this.$store.state.page.initial.funnel : '';
		},
		groups(){
			return this.savedAssetGroups;
		}
	},
	methods: {
		close() {
			this.$emit('close');
		},
		async add() {
			try {
				this.loading = true;

				let res = await this.api.assets.createGroup(this.group);
				if (res && res.error) {
					throw res
				}
				res.assets = [];
				this.groups.push(res)
				// if (this.current_popup && this.current_popup.id===this.popup.id) {
				// 	this.$store.commit('PAGE_SET_TAB', null) // to prevent undefined in props.
				// 	this.$store.commit('PAGE_SET_POPUP', null)
				// }
				// this.$info("Popup deleted successfully!");
				this.$emit('done', res);
			} catch (e) {
				this.$error(e)
			} finally {
				this.loading = false;
			}
		}
	},
	created() {
	}
}
</script>
<style lang="scss" scoped>
.__content {
	padding: 20px 10px 10px 10px;
}
</style>
<style lang="scss" >
.new-asset-group-popup {
	.popup {
		max-width: 450px;
	}
	.content {
		//padding: 0;
		p {
			margin-block-start: 5px;
			margin-block-end: 5px;
		}
	}
	.popup_header {
		margin: 0;
	}
}
</style>
